<template>
  <div class="add-ret-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="handleReturn">
            <i class="el-icon-arrow-left"></i>
            中药采购退货列表
          </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ modeText }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主内容区域 - 整合第一个文件的模态框内容 -->
    <div class="main-content-wrapper">
      <div class="purchase-detail-content">
        <!-- 新增 -->
        <div class="addAcc" ref='myBox'>
            <!-- tabs -->
            <div class="tabs">
                <div class="tabsMain">
                    <!-- 表单 header -->
                    <div class="header-section">
                        <h4 class="section-title">基本信息</h4>
                        <div class="headerForm">       
              <el-form ref="addForm" :rules="addFormRules" :model="addForm" label-width="100px" size="mini" :label-position="labelPosition">
                                <el-row :gutter="16">
                                    <el-col :xs="val.xs" :sm="val.xs" :md="val.md" :lg="val.lg" :xl="val.xl" type="flex" v-for="(val,i) in formType" :key="i">
                                        <!-- input -->
                                        <el-form-item v-if="val.type == 'input'" :label="val.label" :prop="val.modelValue">
                                            <el-input :suffix-icon='val.prefix' v-model="$data.addForm[val.modelValue]" :placeholder="val.placeholder" :disabled="val.disabled" ></el-input>
                                        </el-form-item>
                                        <!-- textarea -->
                                        <el-form-item v-if="val.type == 'textarea'" :label="val.label" :prop="val.modelValue">
                                            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="$data.addForm[val.modelValue]"></el-input>
                                        </el-form-item>
                                        <!-- select -->
                                        <el-form-item v-if="val.type == 'select'" :label="val.label" :prop="val.modelValue">
                                            <el-select v-model="$data.addForm[val.modelValue]" filterable placeholder="请选择" @focus="sname(val,i)"
                                                @change="handleChange" :disabled="val.disabled">
                                                <el-option v-for="item in $data[val.op]" :key="item.id" :label="item.label" :value="item.id"> 
                                                    <span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <!-- date -->
                                        <el-form-item v-if="val.type == 'date'" :label="val.label" :prop="val.modelValue">
                                            <el-date-picker
                                                    :picker-options="pickerOptions" :disabled="val.disabled ? true : false"
                                                    value-format="yyyy-MM-dd"
                                                    type="date" placeholder="选择日期" v-model="$data.addForm[val.modelValue]">
                                            </el-date-picker>
                                        </el-form-item>
                                        <!-- btn -->
                                        <el-form-item v-if="val.type == 'btn'">
                                            <el-button type="primary" plain @click="clickEvents(val,i)">{{ val.label }}</el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                    
                    <!-- 表单数据！第二层取addForm下的list -->
                    <div class="main-section">
                        <h4 class="section-title">中药药品明细</h4>
                        <div class="mainForm">
                            <el-form ref="addMainForm" :rules="addMainFormRules" :model="addMainForm" label-width="100px" size="mini">
                                <el-row :gutter="16">
                                    <el-col :xs="val.xs" :sm="val.xs" :md="val.md" :lg="val.lg" :xl="val.xl" type="flex" v-for="(val,i) in formMainType" :key="i">
                                        <!-- select one -->
                                        <el-form-item v-if="val.type == 'selectFirst'" :label="val.label" :prop="val.modelValue">
                                            <el-select v-model="$data.addMainForm[val.modelValue]" clearable :disabled="val.disabled ? disabled : val.disabled" filterable
                         @focus="handlefoucs(val,i)" @change="handleChangeDrug" @clear="clearSelect" :filter-method="searchMethod" :popper-append-to-body="false">
                                                <el-group>
                                                  <!-- 固定头部 -->
                                                  <div class="select-header" slot="header"
                                                    style="font-size: 12px;font-weight: bold;display: flex;justify-content: space-around;padding: 8px;text-align: left;
                                                    position: sticky;top:0;z-index: 10;background-color: #f1f1f1;">
                                                    <span style="text-align:center;">库存序号</span>
                                                    <span>药品名称</span>
                                                    <span>药品规格</span>
                          <span>库存数量</span>
                                                    <span>批次号</span>
                          <span>生产厂家</span>
                                                  </div>
                                                  
                                                  <!-- 选项内容 -->
                                                  <el-option 
                                                    v-for="item in filteredNameOption" 
                                                    :key="item.id" 
                                                    :label="item.label" 
                                                    :value="item.id"
                                                    :disabled="item.disabled"> 
                                                    <div id="optionItem">
                                                      <span style="text-align:center;">{{ item.id }}</span>
                                                      <span>{{ item.drugName }}</span>
                                                      <el-tooltip class="item" effect="light" :content="item.drugSpec" placement="top">
                                                        <span>{{ item.drugSpec }}</span>
                                                      </el-tooltip>
                                                      <span>{{ item.purcCnt }}</span>
                                                      <span>{{ item.manuLotnum }}</span>
                            <span>{{ item.prodentpName }}</span>
                                                    </div>
                                                  </el-option>
                                                </el-group>
                      </el-select>
                                        </el-form-item>
                                        <!-- select -->
                                        <el-form-item v-if="val.type == 'select'" :label="val.label" :prop="val.modelValue">
                                            <el-select v-model="$data.addMainForm[val.modelValue]" :disabled="val.disabled ? disabled : val.disabled" filterable>
                                                <el-option v-for="item in $data[val.op]" :key="item.id" :label="item.label" :value="item.id">
                                                    <span style="font-size: 12px">{{ item.label }}</span></el-option>
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                    <!-- input 数量 -->
                    <el-form-item v-if="val.type == 'inputNum'" :label="val.label" :prop="val.modelValue">
                      <el-input placeholder="" v-model="$data.addMainForm[val.modelValue]" class="input-with-select" @input="gotoPrice">
                          <el-select v-model="purcType" slot="prepend" @change="SelectedPurcType" placeholder="库存类型"
                          style="width: 98px;">
                            <el-option label="最小单位" value="1"></el-option>
                            <el-option label="包装单位" value="2"></el-option>
                          </el-select>
                          <span slot="append" icon="el-icon-search">{{ purcType == 1 ? minUnt : unt }}</span>
                        </el-input>
                      <!-- <el-input :suffix-icon='val.prefix' v-model="$data.addMainForm[val.modelValue]" @blur="handleInput(val,i)" :disabled="val.disabled" ></el-input> -->
                    </el-form-item>
                                        <!-- input -->
                                        <el-form-item v-if="val.type == 'input'" :label="val.label" :prop="val.modelValue">
                                            <el-input :suffix-icon='val.prefix' v-model="$data.addMainForm[val.modelValue]" @input="handleInput(val,i)" 
                                                      :disabled="val.disabled"></el-input>
                                        </el-form-item>
                                        <!-- textarea -->
                                        <el-form-item v-if="val.type == 'textarea'" :label="val.label" :prop="val.modelValue">
                                            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="$data.addMainForm[val.modelValue]"
                                                      :disabled="val.disabled"></el-input>
                                        </el-form-item>
                                        <!-- date -->
                                        <el-form-item v-if="val.type == 'date'" :label="val.label" :prop="val.modelValue">
                                            <el-date-picker class="autoWidth" :picker-options="expyDatePickerOptions" :disabled="val.disabled"
                                                            type="date" placeholder="选择日期" v-model="$data.addMainForm[val.modelValue]">
                                            </el-date-picker>
                                        </el-form-item>
                                        <!-- btn -->
                                        <el-form-item v-if="val.type == 'btn'">
                                            <el-button type="primary" plain @click="clickEvents(val,i)">{{ val.label }}</el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                    
                    <!-- table -->
                    <div class="table-section">
                        <div class="section-header">
                            <h4 class="section-title">已选药品列表</h4>
                            <div class="total-info">
                                <span class="total-item">成本合计：¥{{ cbValue || '0.00' }}</span>
                                <span class="total-item">零售合计：¥{{ lsValue || '0.00' }}</span>
                                <span class="total-item">共 {{ tableData?.length || 0 }} 种药品</span>
                            </div>
                        </div>
                        <div class="table">
                            <el-table :data="tableData" border 
                :style="{ width: '100%' }"
                :cell-class-name="tableCellClassName" 
                @row-dblclick="dbclick" 
                              v-loading="loading"
                              stripe
                            >
                <el-table-column prop="purcType" label="库存类型" width="100">
                  <template slot-scope="{ row }">
                    <span :style="{ color: purcTypeColorMap[row.purcType] }">{{ purcTypeMap[row.purcType] || '未知' }}</span>
                  </template>
                </el-table-column>
                                <!-- 字段映射 -->
                                <el-table-column prop="drugName" label="药品名称" align='center' width="140" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="drugCode" label="药品编码" align='center' width="120"></el-table-column>
                                <el-table-column prop="drugSpec" label="规格描述" align='center' width="150" show-overflow-tooltip></el-table-column>
                                <!-- 在el-table-column中添加可编辑列 -->
                                <el-table-column prop="apllyAmt" label="出库数量" width="120">
                                  <template slot-scope="scope">
                                    <el-input 
                                      v-if="scope.row.editing"
                                      v-model.number="scope.row.apllyAmt"
                                      size="mini"
                                      :max="scope.row.purcCnt"
                                      @change="handleAmountChange(scope.row)"
                                      :title="`最大可出库数量：${scope.row.purcCnt}`"
                                    ></el-input>
                                    <span v-else>{{ scope.row.apllyAmt + scope.row.unt }}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="manuLotnum" label="生产批号" width="120"></el-table-column>
                <el-table-column prop="expyDate" label="有效日期" width="120"></el-table-column>
                <el-table-column prop="prodentpName" label="生产厂家" align='center' width="150" show-overflow-tooltip></el-table-column>
                <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column>
                <!-- fixed -->
                <el-table-column
                  fixed="left" 
                  label="行号" 
                  width="68" 
                  align="center">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <!-- edit -->
                <el-table-column fixed="right" label="操作" width="168">
                  <template slot-scope="scope">
                    <div class="edit-actions">
                      <template v-if="!scope.row.editing">
                        <el-button 
                          type="primary" 
                          size="mini"
                          @click="enableEditing(scope.row)"
                          :title="`当前库存：${scope.row.purcCnt}`"
                          :disabled="isEditing"
                        >编辑</el-button>
                        <el-button 
                          type="danger" 
                          size="mini"
                          @click="deleteRow(scope.$index)"
                          :disabled="isEditing"
                        >删除</el-button>
                      </template>
                      <template v-else>
                        <el-button 
                          type="success" 
                          size="mini"
                          @click="saveEdit(scope.row)"
                          :disabled="scope.row.apllyAmt > scope.row.purcCnt"
                        >保存</el-button>
                        <el-button 
                          type="info" 
                          size="mini"
                          @click="cancelEdit(scope.row)"
                        >取消</el-button>
                      </template>
                    </div>
                  </template>
                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    <!-- 底部操作按钮 -->
    <div class="action-buttons">
      <el-button size="medium" @click="handleReturn">放弃</el-button>
      <el-button size="medium" :disabled="isEditing" type="info" plain @click="draftSubmit" v-if="mode !== 'view'">存为草稿</el-button>
      <el-button size="medium" :disabled="isEditing" type="primary" plain @click="addSubmit" v-if="mode !== 'view'">保存提交</el-button>
      <el-button size="medium" :disabled="isEditing" type="primary" plain @click="editSubmit" v-if="mode === 'edit'">修改提交</el-button>
      <el-button size="medium" :disabled="isEditing" type="success" plain @click="handleAudit" v-if="currentRow && currentRow.state === 2">审核</el-button>
      <el-button size="medium" :disabled="isEditing" type="warning" plain @click="handlePass" v-if="currentRow && currentRow.state === 4">过单</el-button>
    </div>
  </div>
</template>

<script>
// 导入第一个文件的相关模块
import AccType from './addReturnType.js'
import AccMainType from './AddReturnMainType.js'
import addForm from './addForm.js'
import { getLunar } from 'chinese-lunar-calendar'
import { addZYOutbound, editZYdocOut, selectDropDownList, getTretn, selectZYDrug, docOutZYJoin } from "@/api/PSI/shopReturn.js";

export default {
  name: 'AddRet',
  props: {
    currentRow: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: 'add'
    }
  },
  data() {
    // 表单校验取大于0的数字型数据
    var validatePercentage = (rule, value, callback) => { 
        if(value == ''){
            return callback(new Error('出库数量不能为空！'));  
        } else if(value > this.addMainForm.purcCnt){
            return callback(new Error('出库数量不能大于已有的库存数量！'));  
        }
      callback();
    };
    
    return {
      // 第二个页面的数据
      activeDocType: 'return',
      
      // 第一个文件的数据
      //str
      dialogTitle:'新建采购退货【西药】',
      packNum:0,
      getMinMax:0,
      purcType:'1', // 库存类型 = > 判断大小单位 1最小单位,2包装单位
      unt:'', // 包装单位 （数量：盒？包？g?）
      minUnt:'', // 最小单位 （数量：盒？包？g?）
      tableWidth:'', //右侧表格动态宽度
      labelPosition:'right',
      dosUnt:'?', // 动态包装单位
      value:'',
      inputSearchValue:'',
      deptCode:'',
      getLunarDay: '',
      drugName:'',
      appId:'', // * 选择采购计划时的Id
      startDate:'', // * 开始时间
      endDate:'', // * 结束时间
      idx:'',
      cbValue:'',
      lsValue:'',
      currentCell: null, // 单元格隐藏
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      date: new Date().getDate(),
      lunarDate: '',//农历
      // 1 - 3
      firstName:'',
      seconedName:'',
      thirdName:'',
      auditStatus:'5',
      //num
      pageNum: 1, //当前页currentPage
      pageSize: 6,
      KcNum:0, // 库存数量
      totalSize: 10, //总条数
      //ble
      loading:false,
      disabled:true,
      totaldisabled:true,
      addghdwDialog:false,
      selectDisabled:true,
      isEditShow:false,
      innerVisible:false, //内层Model选择采购计划
      oldData: {}, // 用于保存编辑前的数据
      formMainType: [], // 确保初始化为数组
      feetBtn: [], // 确保初始化为数组
      tableData: [], // 确保初始化为数组
      // 添加编辑状态控制变量
      editingRow: null,
      // 添加编辑状态控制变量
      isEditing: false, // 控制是否处于编辑状态
      editDisabledMap: {}, // 用于记录每行的编辑按钮禁用状态
      //arr
      formType:[], // 表单头部内容

      tableRows:[
          { name:"库存数量", prop:"purcCnt", type:"" },{ name:"库存单位", prop:"unt", type:"" },
          { name:"成本单价", prop:"retnPric", type:"" },{ name:"成本金额", prop:"retnAmt", type:"" },
          { name:"零售单价", prop:"salePric", type:"" },{ name:"零售金额", prop:"saleAmt", type:"" },
      ],
      innertableData:[], //内层采购计划数据源
      currentObj:{}, //内层采购计划数据源 = > 单击选择
      currentTable: [],//表格单选
      selectOption:[{id:1,label:'西药库'}],//库房
      stateOptions:[{id:0,label:'草稿'},{id:2,label:'提交'}],
      kcOptions:[{id:1,label:'最小单位',value:'最小单位'},{id:2,label:'包装单位',value:'包装单位'}], // 库存类型
      ghdwOption:[
          {id:1,label:'水富市人民医院',value:'水富市人民医院'},{id:2,label:'昆明灵泽科技有限公司',value:'昆明灵泽科技有限公司'},
      ],
      purcTypeMap:{
          1: '最小单位',
          2: '包装单位',
      },
      purcTypeColorMap: {
          1: '#67C23A',
          2: '#409EFF',
      },
      retnTypeOptions:[
         {id:11,label:'采购退库',value:'采购退库'},{id:12,label:'报损出库',value:'报损出库'},{id:13,label:'过期出库',value:'过期出库'},
         {id:14,label:'捐赠出库',value:'捐赠出库'},{id:15,label:'其他出库',value:'其他出库'},{id:16,label:'输错出库',value:'输错出库'},
         {id:17,label:'科室出库',value:'科室出库'},{id:18,label:'销售出库',value:'销售出库'},{id:19,label:'拆零自动出库',value:'拆零自动出库'},
      ],
      // 表单验证规则 header
      addFormRules:{
          shedId: [{ required: true, message: '请先选择要入库的库房！', trigger: 'change' }],
          supplyCandidateId: [{ required: true, message: '请选择供货单位！', trigger: 'change' }],
          retnTypeId: [{ required: true, message: '请选择出库方式！', trigger: 'change' }],
      },
      // 表单验证规则 main
      addMainFormRules:{
          drugId: [{ required: true, message: '请先选择药品信息！', trigger: 'change' }],
          manuLotnum: [{ required: true, message: '请输入药品的生产批号！', trigger: 'blur' }],
          retnCnt: [
            { required: true, message: '出库的数量为必填项！', trigger: 'blur' },
            { 
              validator: (rule, value, callback) => {
                // 验证是否为非0正整数
                if (!/^[1-9][0-9]*$/.test(value)) {
                  callback(new Error('出库的数量为非0正整数!'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          expyDate: [{ required: true, message: '药品的有效日期不能为空！', trigger: 'change' }],
          purcType: [{ required: true, message: '请先选择库存类型！', trigger: 'change' }],
      },
      // 单据状态 0 草稿,1 回退提交,2 已提交,3 回退审核,4 已审核,5 已过单,6 已作废'
      statusOption:[
          {id:0,label:'草稿'},{id:1,label:'回退提交'},{id:2,label:'已提交'},{id:3,label:'回退审核'},{id:4,label:'已审核'},{id:5,label:'已过单'},{id:6,label:'已作废'},
      ],
      sexOptions:[{id:1,label:'男',value:'男'},{id:2,label:'女',value:'女'}],
      marryiedOptions:[{id:1,label:'未婚',value:'未婚'},{id:2,label:'已婚',value:'已婚'},{id:3,label:'离异',value:'离异'},{id:4,label:'丧偶',value:'丧偶'},{id:5,label:'再婚',value:'再婚'}],
      nameOption:[],
      ckWaysOptions:[],
      //obj
      addForm:{}, // form表单 * 
      addMainForm:{}, // form主体表单 * addForm.list
      lists:{},
      options:[],
      ssrOption:[],
      gysOption:[],
      ManufacturerOptions:[],
      //props
      pickerOptions: {},
      expyDatePickerOptions: {
              disabledDate(time) { return time.getTime() < Date.now() },
              shortcuts: [
                { text: '三个月后',onClick(picker) {const date = new Date();date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);picker.$emit('pick', date);}},
                { text: '半年后',onClick(picker) {const date = new Date();date.setTime(date.getTime() + 3600 * 1000 * 24 * 180);picker.$emit('pick', date);}},
                { text: '明年',onClick(picker) {const date = new Date();date.setTime(date.getTime() + 3600 * 1000 * 24 * 360);picker.$emit('pick', date);}},
                { text: '后年',onClick(picker) {const date = new Date();date.setTime(date.getTime() + 3600 * 1000 * 24 * 720);picker.$emit('pick', date);}},
                { text: '三年后',onClick(picker) {const date = new Date();date.setTime(date.getTime() + 3600 * 1000 * 24 * 360 * 3);picker.$emit('pick', date);}},
                { text: '五年后',onClick(picker) {const date = new Date();date.setTime(date.getTime() + 3600 * 1000 * 24 * 360 * 5);picker.$emit('pick', date);}},
                { text: '十年后',onClick(picker) {const date = new Date();date.setTime(date.getTime() + 3600 * 1000 * 24 * 360 * 10);picker.$emit('pick', date);}},
              ]
            },
            // 在data中添加watch属性 , 使表格能随着 addMainForm 的变化而更新数据。主要需要修改 enableEditing 方法和添加对 addMainForm 的监听。
            watch: {
              addMainForm: {
                handler(newVal) {
                  if (newVal.editing) {
                    // 找到表格中对应的行并更新
                    const index = this.tableData.findIndex(item => item.drugId === newVal.drugId);
                    if (index !== -1) {
                      this.$set(this.tableData, index, newVal);
                    }
                  }
                },
                deep: true
              }
            }
          }
        },
        // 在data中添加一个计算属性来过滤nameOption
        computed: {
          // 模式文本显示
          modeText() {
            const textMap = {
              'add': '新增采购退货',
              'edit': '编辑采购退货',
              'view': '查看采购退货'
            };
            return textMap[this.mode] || '采购退货';
          },
          
          filteredNameOption() {
            // 获取表格中所有的drugId
            const existingDrugIds = this.tableData.map(item => item.drugId);
            // 过滤掉已经存在于表格中的药品
            return this.nameOption.filter(item => !existingDrugIds.includes(item.id));
          }
        },
        created() {
          
        },
        mounted() {
          // 获取接口参数
          this.getAddForm();
          this.ckWays();
          this.getGys();
          // 获取当前日期时间
          this.getNowDateTime();
          
          // 如果是编辑或查看模式，加载数据
          if (this.mode === 'edit' || this.mode === 'view') {
            this.loadRowData();
          }
        },
        methods: {
          // 采购计划数据
          async loadData(){
              let res = await getPurchasingPlan({
                  auditStatus:this.auditStatus,
                  startDate:this.startDate,
                  endDate:this.endDate,
                  pageNum:this.pageNum,
                  pageSize:this.pageSize,
              });
              if(res.code == 200){
                  this.innertableData = res.data.content
                  this.totalSize = res.data.totalSize
              }else{
                  this.$message({type: 'error',message: res.message});
              }
          },
          
          /* 入库药品数据源 */
          async getProData() {
            let res = await selectZYDrug({
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              drugName: this.drugName
            });
            
            if (res.code === 200) {
              // 按照 drugName 进行排序
              const sortedData = res.data.content.sort((a, b) => {
                // 如果 drugName 相同，可以按照其他字段排序（如 drugId）
                if (a.drugName === b.drugName) {
                  return a.drugId - b.drugId;
                }
                // 否则按照 drugName 升序排序
                return a.drugName.localeCompare(b.drugName);
              });
              
              // 将排序后的数据赋值给 nameOption
              this.nameOption = sortedData.map(obj => ({
                label: obj.drugName,
                ...obj
              }));
            } else {
              this.$message.error(res.message);
            }
          },
          /* props => 生产厂家模糊查询 */
          searchMethod(query, option) {
              console.log(query);
              if(query){
                  console.log(query,'再调一次接口查询');
                  this.inputSearchValue = query
                  this.pageNum = 1
                  this.pageSize = 10
                  this.drugName = query
                  this.getProData();
              }else{
                  console.log('buzou');
              }
          },
          // select聚焦
          async handlefoucs(val,i){
              this.idx = i;
              console.log(i);
              switch (i) {
                  case 0: // 药典名称
                      this.getProData();
                  break;
              }
          },
          // 表格单选 => getPlan
          handleCurrentTableChange(val){
              if(val.state != 5){
                  this.setCurrent();
                  this.$message({ type: 'error', message: '只能选择已过单数据!'});
              }else{
                  // 赋id
                  this.appId = val.id
                  this.currentTable = val
                  this.$message({ type: 'success', message: '已选择:' + this.appId + '的采购计划数据'});
              }
          },
          // 取消高亮
          setCurrent(row) {
              this.$refs.singleTable.setCurrentRow(row);
          },
          // 表单头部聚焦事件 => addForm
          async sname(val,i) {
              // val.id = i;
              this.idx = i;
              console.log(i);
          },
          // 表单主体聚焦事件 => addMainForm
          async foucsSelect(v,i){
              // val.id = i;
              this.idx = i;
              console.log(i);
              // i event
              switch (i) {
                  case 0:
                      // 药品下拉选择框
                      let res = await selectZYDrug()
                      console.log(res.data.content)
                      this.nameOption = res.data.content.map(obj => {
                        // 将 name 替换为 label，并保留其他字段
                        return { label: obj.drugName , ...obj };
                      });
                  break;
              }
          },
          // 计算总金额
          getTotalAmt(){
              let cbTotal = 0;
              let lsTotal = 0;
              if(this.tableData.length === 0){
                  this.addForm.costAmt = this.addMainForm.retnAmt = this.addMainForm.retnPric * this.addMainForm.purcCnt // 成本金额
                  this.addForm.saleAmt = this.addMainForm.saleAmt = this.addMainForm.salePric * this.addMainForm.purcCnt // 零售金额
                  this.cbValue = this.addForm.costAmt;
                  this.lsValue = this.addForm.saleAmt;
              }else{
                  this.addForm.costAmt = this.addMainForm.retnAmt = this.addMainForm.retnPric * this.addMainForm.purcCnt // 成本金额
                  this.addForm.saleAmt = this.addMainForm.saleAmt = this.addMainForm.salePric * this.addMainForm.purcCnt // 零售金额
                  this.tableData.forEach(row => {
                      cbTotal += row.retnAmt;
                      lsTotal += row.saleAmt;
                  });
                  this.addForm.costAmt = this.cbValue = cbTotal;
                  this.addForm.saleAmt = this.lsValue = lsTotal;
              }
          },
          handleInput(v,i){
              this.idx = i;
              console.log(i);
              // i event
              switch (i) {
                  case 11:
                      this.getTotalAmt();
                  break;
              }
          },
          // 调用接口查询是否可加入
          async isJoined() {
            // 检查是否已存在相同药品ID
            const exists = this.tableData.some(item => item.drugId === this.addMainForm.drugId);
            if (exists) {
              this.$message.error('该药品已存在于列表中！');
              // 获取表格中所有的drugId
              const existingDrugIds = this.tableData.map(item => item.drugId);
              // 过滤掉已经存在于表格中的药品
              return this.nameOption.filter(item => !existingDrugIds.includes(item.id));
            }
            
            let reslut = await docOutZYJoin({ 
              amount: this.addMainForm.retnCnt,
              invId: this.addMainForm.invId,
              pacCnt:this.packNum,
              purcType:this.purcType
            });
            
            if(reslut.code === 200) {
              this.loading = true;
              setTimeout(() => {
                // 处理返回的数据，计算金额
                const processedData = reslut.data.map(item => ({
                  ...item,
                  saleAmt: item.salePric * item.apllyAmt,
                  retnAmt: item.retnPric * item.apllyAmt
                }));
                
                if(this.tableData.length === 0) {
                  // 如果表格为空，直接赋值
                  this.tableData = processedData;
                } else {
                  // 如果表格不为空，直接添加新数据
                  this.tableData = [...this.tableData, ...processedData];
                }
                
                // 计算总金额
                this.cbValue = this.tableData.reduce((sum, item) => sum + item.retnAmt, 0);
                this.lsValue = this.tableData.reduce((sum, item) => sum + item.saleAmt, 0);
                
                // 更新表单中的总金额
                this.addForm.costAmt = this.cbValue;
                this.addForm.saleAmt = this.lsValue;
                
                this.$message.success('已添加！');
                this.loading = false;
              }, 888);
                this.$refs['addMainForm'].resetFields();
            } else {
              this.$message.error(reslut.message);
            }
          },
          // 库存类型选择
          SelectedPurcType(val){
              this.addMainForm.purcType = val
              console.log(this.addMainForm.purcType,'this.addMainForm.purcTypethis.addMainForm.purcType');
              if(this.addMainForm.purcType == 1){
                  this.addMainForm.retnCnt = this.addMainForm.retnCnt * this.getMinMax // 最小单位成本单价
              }else{
                  this.addMainForm.retnCnt = this.addMainForm.retnCnt / this.getMinMax; // 最大单位成本单价
                  // 验证 retnCnt 是否为非0正整数
                    if (this.addMainForm.retnCnt) {
                      const regex = /^[1-9][0-9]*$/; // 非0正整数正则表达式
                      
                      if (!regex.test(this.addMainForm.retnCnt)) {
                        this.$message({
                          type: 'error',
                          message: '入库数量的最大单位必须是非0正整数!'
                        });
                        this.addMainForm.retnCnt = ''
                        return; // 如果验证失败，直接返回不执行后续逻辑
                      }
                    }
              }
          },
          gotoPrice(v){
              if(v.length > 5){
                  this.$message({type: 'error',message: '有效数量长度最高暂时为5位数...' });
              }else if(this.purcType == 1){
                  console.log(this.purcType,'输入数量leix'); // 最小单位成本单价
              }
          },
          // 查看单据数据
          watchData(){
              this.$message({type: 'waring',message: '正在开发中...' });
          },
          // 当前日期时间
          formatDate(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day}`;
          },
          // 将当前日期时间设置为夜晚十一点五十九分
          getNowDateTime(){
              // 获取当前日期时间
              this.addForm.busDate = this.formatDate(new Date);
              this.addForm.createTime = this.formatDate(new Date);
              // this.addForm.createTime = this.formatDate(new Date);
              // 获取制单人 => 当前登录用户
              this.addForm.createId = JSON.parse(localStorage.getItem('userInfo')).userId;
              this.addForm.creater = JSON.parse(localStorage.getItem('userInfo')).username;
              // 获取诊所Id => 当前登录用户
              this.addMainForm.clinicId = JSON.parse(localStorage.getItem('userInfo')).clinicId;
              // 获取终端序号 => 当前登录用户
              this.addForm.terminalId = localStorage.getItem('terminalId');
          },
          // 开始时间变化值
          startDateHandle(value){ if (value) {this.startDate = this.formatDate(value)}},
          // 结束时间变化值
          endDateHandle(value){ if (value) {this.endDate = this.formatDate(value)}},
          // 时间处理
          changDate(val){
              let i = this.idx
              switch(i) {
                  case 5:
                  function formatDate(date) {
                    const year = date.getFullYear();
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const day = date.getDate().toString().padStart(2, '0');
                    return `${year}-${month}-${day}`;
                  }
                  // 使用示例
                  const now = new Date();
                  this.addForm.busDate = formatDate(val);
              }
          },
          // 出库方式下拉列表
          async ckWays(){
              let rs = await getTretn();
              this.ckWaysOptions = rs.data.map(obj => {
                // 将 name 替换为 label，并保留其他字段
                return { label: obj.name , ...obj };
              });
              console.log(this.ckWaysOptions,'pppppppppppp');
          },
          // 供应商下拉列表
          async getGys(){
              let rs = await selectDropDownList()
              this.gysOption = rs.data.content.map(obj => {
                // 将 name 替换为 label，并保留其他字段
                return { label: obj.supplierName , ...obj };
              });
          },
          // 下拉选项清空事件
          clearSelect(){
              this.getProData();
          },
          handleInputPacCut(v,i){
              this.idx = i;
              console.log(i);
              // i event
              switch (i) {
                  case 8:
                  let purcCntRule = /^[1-9]\d*$/;
                  if(!purcCntRule.test(this.addMainForm.purcCnt)){
                      this.$message({ type: 'error', message: '请输入正确的出库数量，请注意格式!'});
                  }else{
                      this.getMarkUpPric();
                      this.getPageListCheck(); // 检测库存是否充足
                  }
                  break;
              }
          },
          // 直接计算销售金
          getMarkUpPric(drugrs){
              this.addForm.costAmt = this.addMainForm.retnPric * Number(this.addMainForm.retnCnt)     // 成本金额
              this.addForm.saleAmt = this.addMainForm.salePric * Number(this.addMainForm.retnCnt); // 零售金额
              this.addMainForm.retnAmt = this.addMainForm.retnPric * Number(this.addMainForm.retnCnt)     // 成本金额 =》 明细
              this.addMainForm.saleAmt = this.addMainForm.salePric * Number(this.addMainForm.retnCnt); // 零售金额 =》 明细
              // console.log(this.addMainForm.retnPric,'怕怕怕怕怕怕怕怕怕怕怕怕怕怕怕怕怕',this.addMainForm.retnCnt);
              this.cbValue = this.addForm.costAmt
              this.lsValue = this.addForm.saleAmt
          },
          // SelectVal to editForm
          handleChange(val){
              console.log(val);
              if(val){
                  this.disabled = false
              }
              // i event
          },
          handleChangeDrug(val){
              let drugrs = this.nameOption.find(name => name.id === val)
              console.log(drugrs,'drugrsdrugrsdrugrs');
              this.getMinMax = drugrs.pacCnt // 大小单位转换
              // this.addMainForm.id = drugrs.drugId
              this.addMainForm.label = drugrs.drugName
              this.addMainForm.purcCnt = drugrs.purcCnt
              this.addMainForm.drugCode = drugrs.drugCode
              this.addMainForm.invId = drugrs.id
              // this.addMainForm.drugId = drugrs.drugId
              this.addMainForm.manuLotnum = drugrs.manuLotnum
              this.addMainForm.drugSpec = drugrs.drugSpec
              this.addMainForm.retnPric = drugrs.purcPric
              this.KcNum =  drugrs.purcCnt // 库存数量
              this.unt = drugrs.pacUnt // 包装单位
              this.purcType = this.addMainForm.purcType = String(drugrs.purcType);
              this.minUnt = drugrs.dosUnt // 最小单位
              this.addMainForm.salePric = drugrs.salePric
              this.dosUnt = this.addMainForm.unt = drugrs.unt
              this.addMainForm.prodentpName = drugrs.prodentpName
              this.addMainForm.prodentpId = drugrs.prodentpNameId
              this.packNum = drugrs.pacCnt // 包装数量
          },
          //新增保存
          async addSubmit(){
              //触发验证表单
              this.$refs.addForm.validate(async(valid) => {
                  if(valid){
                      this.addForm.state = 2
                      this.addForm.list = this.tableData
                      console.log(this.addForm);
                      let result = await addZYOutbound(this.addForm)
                      if (result.code === 200) {
                          this.$message({ type: 'success', message: result.message });
                          this.handleReturn();
                      } else {
                          this.$message.error(result.message)
                      }
                  }
              })
          },
          // 修改新增保存
          async editSubmit(){
              //触发验证表单
              this.$refs.addForm.validate(async(valid) => {
                  if(valid){
                      this.addForm.state = 2
                      this.addForm.list = this.tableData
                      console.log(this.addForm);
                      let result = await editZYdocOut(this.addForm)
                      if (result.code === 200) {
                          this.$message({ type: 'success', message: result.message });
                          this.handleReturn();
                      } else {
                          this.$message.error(result.message)
                      }
                  }
              })
          },
          checkedNum(){
              if(this.addMainForm.purcType == 1){
                  this.addMainForm.retnCnt = this.addMainForm.retnCnt
              }else{
                  this.addMainForm.retnCnt = Number(this.addMainForm.retnCnt) * this.packNum
              }
          },
          // 草稿保存
          async draftSubmit(){
              //触发验证表单
              this.$refs.addForm.validate(async(valid) => {
                  if(valid){
                      this.addForm.state = 0
                      this.addForm.list = this.tableData
                      let result = await addZYOutbound(this.addForm)
                      if (result.code === 200) {
                         this.$message({ type: 'success', message: result.message });
                          this.handleReturn();
                      } else {
                          this.$message.error(result.message)
                      }
                  }
              })
          },
          // 修改草稿保存
          async draftEditSubmit(){
              console.log(this.addForm,'this.addFormthis.addFormthis.addForm');
              //触发验证表单
              this.$refs.addForm.validate(async(valid) => {
                  if(valid){
                      this.addForm.state = 0
                      this.addForm.list = this.tableData
                      let result = await editZYdocOut(this.addForm)
                      if (result.code === 200) {
                          this.$message({ type: 'success', message: result.message });
                          this.handleReturn();
                      } else {
                          this.$message.error(result.message)
                      }
                  }
              })
          },
          // 加载行数据（编辑/查看模式）
          loadRowData() {
            if (this.currentRow) {
              // 加载数据
              this.addForm = { ...this.currentRow };
              this.tableData = this.currentRow.list || [];
              
              // 计算总金额
              this.calculateTotals();
              
              // 设置编辑状态
              this.isEditShow = this.mode === 'edit';
            }
          },
          // 根据选择的id去查找id对应的对象
          foundObj(){
              let rs = this.gysOption.find(name => name.id === val)
          },
          // 删除行（修正版本）
          deleteRow(index) {
              this.$confirm('确定要删除此行吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                // 确保tableData存在且是数组
                if (Array.isArray(this.tableData)) {
                  this.tableData.splice(index, 1);
                  this.$message.success('删除成功');
                  // 重新计算合计
                  this.calculateTotals();
                } else {
                  this.$message.error('数据异常，无法删除');
                }
              }).catch(() => {
                this.$message.info('已取消删除');
              });
          },
          handleSelectCost(val) {
            this.addForm.nativePlace = val.join(',')
          },
          // db events
          // 给单元格绑定横向和竖向的index，这样就能确定是哪一个单元格
          tableCellClassName({row, column, rowIndex, columnIndex}){
              row.index = rowIndex;
              column.index = columnIndex;
          },
          // 当input失去焦点的时候，隐藏input
          hideInput(){
              this.currentCell = null;
          },
          // 获得当前双击的单元格的横竖index，然后拼接成一个唯一字符串用于判断，并赋给currentCell  // 拼接后类似这样："1,0","1,1",
          dbclick(row,column) {
              console.log(column.index);
          },
          // db events
          handledbRow(row, column, event){
              if(row){ this.addForm = row; this.watchDialogVisible = true } else { console.log('fail'); }
              // console.log(this.addForm);
              this.formdisabled = true
          },
          // col 里面包含了表头字段和名称，list 是表格数据
          columnWidth(col, list) {
            let prop = col.prop,lab = col.lab;
            let width = 40; // 设定一个最小值
            let maxlenStr = ""; // 最长字符串
            for (let info of list) { if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop] }
            width = Math.max(width, len(lab), len(maxlenStr));
            // 表格自带的内边距(20px) 自调
            return width + 24; // 这里加了 12px
            function len(str) {
              // 实际分配长度可根据需要自行调整
              let length = 12;
              for (const char of str + "") {
                // 英文小写字符 8px
                if ("a" <= char && char <= "z") length += 8;
                // 英文大写字符 8px
                else if ("A" <= char && char <= "Z") length += 8;
                // 中文字符 28px
                else if (char >= "\u4e00" && char <= "\u9fa5") length += 28;
                // 其他 8px
                else length += 12;
              }
              return length;
            }
          },
          // 挂载或销毁前后重新赋值后端参数
          getAddForm(){
              // 左侧提交表单
              this.addForm = addForm.map(v => {return v })[0]; // Form
              this.addMainForm = this.addForm.list[0]
              console.log(this.addForm,'原始的接口参数数据');
              // 定义数据来源
              this.formType = AccType.map(function(val) { return val })
              this.formMainType = AccMainType.map(function(val) { return val })
          },
          //分页
          //每页条数改变触发
          handleSizeChange(val) {
              console.log(`每页 ${val} 条`);
              this.pageNum = val;
              this.loadData();
          },
          //当前条数改变触发
          handleCurrentChange(val) {
              console.log(`当前页: ${val}`);
              this.pageNum = val;
              this.loadData();
          },
          // 库存序号判断
          async getPageListCheck(){
              if(this.addMainForm.drugId == ''){
                  this.$message({ type: 'error', message: '请先选择正确的药品信息!'});
              } else if(this.addMainForm.prodentpNameId == ''){
                  this.$message({ type: 'error', message: '关联的厂家序号错误，请重试。'});
              } else if(this.addMainForm.purcCnt > this.KcNum){
                  // this.$message({ type: 'error', message: '调拨数量不能大于当前库存数量！【当前库存数量】：'+this.KcNum});
                  this.$confirm('调拨数量不能大于【当前库存数量】！', '提示', {
                    confirmButtonText: 'OK',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {}).catch(() => {
                    this.$message({ type: 'info', message: '已取消'});          
                  });
                  this.addMainForm.purcCnt = 1;
              }
          },
          // 启用编辑状态（独立编辑模式）
          enableEditing(row) {
            // 禁用底部所有按钮
            this.isEditing = true;
            
            // 先取消其他行的编辑状态
            this.tableData.forEach(item => {
              if (item.editing && item !== row) {
                this.$set(item, 'editing', false);
              }
            });
            
           // 保存原始数据用于取消编辑时恢复
                 this.$set(row, '_originalData', JSON.parse(JSON.stringify(row)));
                 this.$set(row, 'editing', true);
               },
               
               // 保存编辑
               saveEdit(row) {
                 // 验证出库数量是否有效
                 if (!row.apllyAmt || row.apllyAmt <= 0) {
                   this.$message.error('出库数量必须大于0');
                   return;
                 }
                 
                 if (row.apllyAmt > row.purcCnt) {
                   this.$message.error(`出库数量不能大于库存数量（当前库存：${row.purcCnt}）`);
                   return;
                 }
                 
                 // 重新计算当前行金额
                 row.retnAmt = row.retnPric * row.apllyAmt;
                 row.saleAmt = row.salePric * row.apllyAmt;
                 
                 // 退出编辑状态
                 this.$set(row, 'editing', false);
                 delete row._originalData;
                 
                 // 重新计算合计
                 this.calculateTotals();
                 
                 // 启用底部按钮
                 this.isEditing = false;
                 
                 this.$message.success('保存成功');
               },
               
               // 取消编辑
               cancelEdit(row) {
                 // 恢复原始数据
                 if (row._originalData) {
                   Object.assign(row, row._originalData);
                   delete row._originalData;
                 }
                 
                 // 退出编辑状态
                 this.$set(row, 'editing', false);
                 
                 // 启用底部按钮
                 this.isEditing = false;
               },
               
               // 处理数量变化
               handleAmountChange(row) {
                 // 确保是数字
                 row.apllyAmt = Number(row.apllyAmt) || 0;
                 
                 // 实时验证库存数量
                 if (row.apllyAmt > row.purcCnt) {
                   this.$message.warning(`出库数量不能大于库存数量（当前库存：${row.purcCnt}）`);
                   row.apllyAmt = row.purcCnt;
                   return;
                 }
                 
                 // 验证非负数
                 if (row.apllyAmt < 0) {
                   row.apllyAmt = 0;
                   return;
                 }
                 
                 // 计算当前行金额
                 row.retnAmt = row.retnPric * row.apllyAmt;
                 row.saleAmt = row.salePric * row.apllyAmt;
               },
               
               // 计算合计（独立计算）
               calculateTotals() {
                 this.cbValue = this.tableData.reduce((sum, item) => {
                   return sum + (Number(item.retnAmt) || 0);
                 }, 0);
                 
                 this.lsValue = this.tableData.reduce((sum, item) => {
                   return sum + (Number(item.saleAmt) || 0);
                 }, 0);
                 
                 // 更新表单总金额（不影响其他数据）
                 this.addForm.costAmt = this.cbValue;
                 this.addForm.saleAmt = this.lsValue;
               },
               
               // 循环加入按钮点击事件
               clickEvents(val, i) {
                 this.idx = i;
                 switch (i) {
                   case 8:
                     // 如果是编辑状态，则更新当前编辑的行
                     if (this.addMainForm.editing) {
                       this.saveEdit(this.addMainForm);
                     } else {
                       // 否则正常加入新数据
                       this.$refs.addMainForm.validate(async(valid) => {
                         if(valid){
                           this.isJoined();
                         }
                       });
                     }
                     break;
                 }
               },
               
               // 返回列表
               handleReturn() {
                 // 检查是否有未保存的更改
                 if (this.hasUnsavedChanges()) {
                   this.$confirm('关闭此界面会清空现已选择的内容, 是否继续?', '提示', {
                     confirmButtonText: '确定',
                     cancelButtonText: '取消',
                     type: 'warning'
                   }).then(() => {
                     this.resetAllForms();
                     this.$emit('close');
                   }).catch(() => {
                     this.$message({ type: 'info', message: '已取消关闭' });
                   });
                 } else {
                   this.$emit('close');
                 }
               },
               
               // 审核
               handleAudit() {
                 this.$confirm('确定审核通过吗？', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
                 }).then(() => {
                   this.auditData();
                 }).catch(() => {});
               },
               
               // 审核数据
               async auditData() {
                 try {
                   if (!this.currentRow || !this.currentRow.id) {
                     this.$message.error('无效的数据');
                     return;
                   }
                   
                   const params = {
                     id: this.currentRow.id,
                     state: 4 // 审核通过状态
                   };
                   
                   const res = await toRetnExamine(params);
                   if (res.code === 200) {
                     this.$message.success('审核成功');
                     this.$emit('refresh');
                     this.$emit('close');
                   } else {
                     this.$message.error(res.message || '审核失败');
                   }
                 } catch (error) {
                   console.error('审核失败:', error);
                   this.$message.error('审核失败');
                 }
               },
               
               // 过单
               handlePass() {
                 this.$confirm('确定过单吗？过单后将完成整个流程', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
                 }).then(() => {
                   this.passData();
                 }).catch(() => {});
               },
               
               // 过单数据
               async passData() {
                 try {
                   if (!this.currentRow || !this.currentRow.id) {
                     this.$message.error('无效的数据');
                     return;
                   }
                   
                   const params = {
                     id: this.currentRow.id,
                     state: 5 // 已过单状态
                   };
                   
                   const res = await toRetnExamine(params);
                   if (res.code === 200) {
                     this.$message.success('过单成功');
                     this.$emit('refresh');
                     this.$emit('close');
                   } else {
                     this.$message.error(res.message || '过单失败');
                   }
                 } catch (error) {
                   console.error('过单失败:', error);
                   this.$message.error('过单失败');
                 }
               },
               
               // 反审核
               handleReverseAudit() {
                 this.$confirm('确定要反审核吗？', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
                 }).then(() => {
                   this.reverseAuditData();
                 }).catch(() => {});
               },
               
               // 反审核数据
               async reverseAuditData() {
                 try {
                   if (!this.currentRow || !this.currentRow.id) {
                     this.$message.error('无效的数据');
                     return;
                   }
                   
                   const params = {
                     id: this.currentRow.id,
                     state: 2 // 返回到待审核状态
                   };
                   
                   const res = await toRetnExamine(params);
                   if (res.code === 200) {
                     this.$message.success('反审核成功');
                     this.$emit('refresh');
                     this.$emit('close');
                   } else {
                     this.$message.error(res.message || '反审核失败');
                   }
                 } catch (error) {
                   console.error('反审核失败:', error);
                   this.$message.error('反审核失败');
                 }
               },
               
               // 打印
               handlePrint() {
                 this.$confirm('请选择打印方式', '打印设置', {
                   confirmButtonText: 'Lodop打印',
                   cancelButtonText: '浏览器打印',
                   type: 'warning'
                 }).then(() => {
                   this.printWithLodop();
                 }).catch(() => {
                   this.printWithBrowser();
                 });
               },
               
               // Lodop打印
               printWithLodop() {
                 // 实际项目中这里应该调用打印接口
                 this.$message.info('Lodop打印功能');
               },
               
               // 浏览器打印
               printWithBrowser() {
                 window.print();
               },
               
               // 检查是否有未保存数据的方法
               hasUnsavedChanges() {
                 // 检查主表单是否有数据
                 const hasFormData = Object.values(this.addForm).some(value => {
                   if (value === null || value === undefined || value === '') return false;
                   if (Array.isArray(value)) return value.length > 0;
                   if (typeof value === 'object') return Object.keys(value).length > 0;
                   return true;
                 });
                 
                 // 检查表格是否有数据
                 const hasTableData = this.tableData.length > 0;
                 
                 return hasFormData || hasTableData;
               },
               
               // 重置所有表单和状态
               resetAllForms() {
                 // 重置主表单
                 this.addForm = addForm.map(v => ({ ...v }))[0];
                 
                 // 重置明细表单
                 this.addMainForm = { ...this.addForm.list[0] };
                 
                 // 重置表格数据
                 this.tableData = [];
                 
                 // 重置金额合计
                 this.cbValue = '';
                 this.lsValue = '';
                 
                 // 重置其他状态
                 this.isEditing = false;
                 this.purcType = '1';
                 this.unt = '';
                 this.minUnt = '';
                 this.packNum = 0;
                 this.getMinMax = 0;
                 
                 // 重置表单验证
                 if (this.$refs.addForm) {
                   this.$refs.addForm.resetFields();
                 }
                 if (this.$refs.addMainForm) {
                   this.$refs.addMainForm.resetFields();
                 }
                 
                 // 重置当前日期时间
                 this.getNowDateTime();
               },
               
               // 处理单据类型变化
               handleDocTypeChange() {
                 this.$message.info('切换到退货单模式');
               }
             }
           }
           </script>
           
           <style lang="less" scoped>
           .add-ret-container {
             height: calc(90vh - 40px);
             display: flex;
             flex-direction: column;
             background-color: #f5f7fa;
             padding: 15px;
             overflow: hidden;
             
             .breadcrumb-header {
               background: #fff;
               padding: 10px 15px;
               border-radius: 4px;
               margin-bottom: 15px;
               box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
               
               .el-breadcrumb {
                 font-size: 14px;
                 
                 a {
                   color: #00557f;
                   text-decoration: none;
                   
                   &:hover {
                     color: #007acc;
                   }
                   
                   .el-icon-arrow-left {
                     margin-right: 5px;
                   }
                 }
               }
             }
             
             .page-header {
               display: flex;
               justify-content: space-between;
               align-items: center;
               background: #fff;
               padding: 15px;
               border-radius: 4px;
               margin-bottom: 15px;
               box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
               
               .doc-type-tabs {
                 .el-radio-group {
                   .el-radio-button {
                     .el-radio-button__inner {
                       padding: 10px 20px;
                       font-size: 16px;
                       font-weight: bold;
                     }
                   }
                 }
               }
               
               .doc-info {
                 display: flex;
                 align-items: center;
                 
                 .doc-date, .doc-number {
                   display: flex;
                   align-items: center;
                   margin-left: 20px;
                   
                   span {
                     margin-right: 10px;
                     font-size: 14px;
                   }
                 }
               }
               
               .header-actions {
                 .el-button {
                   margin-left: 5px;
                 }
               }
             }
             
             .main-content-wrapper {
               flex: 1;
               background: #fff;
               border-radius: 4px;
               overflow: hidden;
               box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
               margin-bottom: 15px;
               
               .purchase-detail-content {
                 height: 100%;
                 overflow-y: auto;
                 padding: 20px;
                 
                 // 继承第一个文件的样式
                 .addAcc {
                   .tabs {
                     .tabsMain {
                       display: flex;
                       flex-direction: column;
                       gap: 20px;
           
                       // 各部分标题样式
                       .section-title {
                         font-size: 16px;
                         font-weight: 600;
                         color: #303133;
                         margin-bottom: 16px;
                         padding-left: 8px;
                         border-left: 4px solid #409EFF;
                       }
           
                       // 头部表单区域
                       .header-section {
                         background: #f8f9fa;
                         border-radius: 6px;
                         border: 1px solid #e6e8eb;
           
                         .headerForm {
                           /deep/ .el-form-item {
                             margin-bottom: 12px;
                             
                             .el-form-item__label {
                               font-weight: 500;
                               color: #606266;
                               font-size: 13px;
                             }
                             
                             .el-input__inner {
                               border-radius: 4px;
                               border: 1px solid #dcdfe6;
                               
                               &:hover {
                                 border-color: #c0c4cc;
                               }
                               
                               &:focus {
                                 border-color: #409EFF;
                               }
                             }
                           }
                         }
                       }
           
                       // 主体表单区域
                       .main-section {
                         background: #f8f9fa;
                         border-radius: 6px;
                         border: 1px solid #e6e8eb;
           
                         .mainForm {
                           /deep/ .el-form-item {
                             margin-bottom: 12px;
                             
                             .el-form-item__label {
                               font-weight: 500;
                               color: #606266;
                               font-size: 13px;
                             }
                             
                             .input-with-select {
                               /deep/ .el-select .el-input {
                                 width: 108px;
                               }
                               
                               /deep/ .el-input-group__prepend {
                                 background-color: #f5f7fa;
                               }
                             }
                           }
                           
                           /deep/ .el-select-dropdown__item {
                             border: 1px solid #eeeeee;
                             padding: 0;
                             height: 32px;
                             
                             #optionItem {
                               width: 100%;
                               height: 100%;
                               display: flex;
                               align-items: center;
                               text-align: center;
                               justify-content: space-around;
                               
                               span {
                                 display: inline-block;
                                 font-size: 12px;
                                 height: 32px;
                                 line-height: 32px;
                                 white-space: nowrap;
                                 overflow: hidden;
                                 text-overflow: ellipsis;
                               }
                             }
                           }
                         }
                       }
           
                       // 表格区域
                       .table-section {
                         .section-header {
                           display: flex;
                           justify-content: space-between;
                           align-items: center;
                           margin-bottom: 16px;
           
                           .section-title {
                             font-size: 16px;
                             font-weight: 600;
                             color: #303133;
                             margin: 0;
                             padding-left: 8px;
                             border-left: 4px solid #67C23A;
                           }
           
                           .total-info {
                             display: flex;
                             gap: 20px;
           
                             .total-item {
                               font-size: 14px;
                               color: #606266;
                               font-weight: 500;
           
                               &:first-child {
                                 color: #ff6b35;
                               }
           
                               &:nth-child(2) {
                                 color: #67c23a;
                               }
                             }
                           }
                         }
           
                         .table {
                           /deep/ .el-table {
                             border-radius: 6px;
                             overflow: hidden;
                             border: 1px solid #e6e8eb;
           
                             .el-table__header-wrapper {
                               th {
                                 background-color: #f5f7fa;
                                 font-weight: 600;
                                 color: #606266;
                                 font-size: 13px;
                               }
                             }
           
                             .el-table__body-wrapper {
                               tr:hover > td {
                                 background-color: #f0f7ff;
                               }
                               
                               .cell {
                                 font-size: 12px;
                                 font-weight: 400;
                                 color: #0c0c0c;
                                 text-align: center;
                               }
                             }
           
                             .el-table__cell {
                               padding: 8px 0;
                             }
                           }
                         }
                       }
                     }
                   }
                 }
               }
             }
           
             .action-buttons {
               display: flex;
               justify-content: flex-end;
               padding: 10px 0;
               
               .el-button {
                 margin-left: 10px;
               }
             }
           }
           
           // 响应式设计
           @media (max-width: 1200px) {
             .add-ret-container {
               .page-header {
                 flex-direction: column;
                 align-items: flex-start;
                 
                 .doc-info {
                   margin-top: 10px;
                   margin-left: 0;
                 }
                 
                 .header-actions {
                   margin-top: 10px;
                 }
               }
             }
           }
           
           // 打印样式
           @media print {
             .breadcrumb-header,
             .page-header,
             .action-buttons {
               display: none !important;
             }
             
             .add-ret-container {
               padding: 0;
               background: white;
             }
           }
           
           // 编辑操作按钮样式优化
           .edit-actions {
             display: flex;
             gap: 4px;
             justify-content: center;
             
             .el-button {
               min-width: 50px;
               padding: 6px 8px;
               font-size: 12px;
               
               &.is-disabled {
                 opacity: 0.5;
                 cursor: not-allowed;
               }
             }
           }
           
           // 表格单元格样式优化
           /deep/ .el-table {
             .cell {
               line-height: 1.4;
               
               .el-input {
                 .el-input__inner {
                   height: 28px;
                   line-height: 28px;
                   text-align: center;
                 }
               }
             }
             
             // 库存类型颜色样式
             .purc-type-min {
               color: #67C23A;
               font-weight: 500;
             }
             
             .purc-type-pac {
               color: #409EFF;
               font-weight: 500;
             }
           }
           
           // 选择器下拉框样式优化
           /deep/ .el-select-dropdown {
             border: none;
             box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
             border-radius: 4px;
             
             .el-select-dropdown__item {
               height: 32px;
               line-height: 32px;
               font-size: 13px;
               
               &.selected {
                 color: #409EFF;
                 font-weight: 500;
               }
               
               &:hover {
                 background-color: #f5f7fa;
               }
             }
             
             .select-header {
               background-color: #f5f7fa;
               border-bottom: 1px solid #e6e8eb;
               font-weight: 600;
               color: #303133;
             }
           }
           </style>